<template>
    <div class="img-pro clearfix">
        <div
            v-for="(img,key) in imgs"
            :key="key"
            class="tab-card">
            <img
                :src="img.url"
                :_src="img.url1"
                class="case-img"
                v-if="changeBack"
            >
            <div
                :style="{'background':'url('+ img.url +')'}"
                :_src="img.url1"
                class="case-back"
                v-else="changeBack"
            ></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "change-img",
        props: ['imgs'],
        data() {
            return {
                changeBack: true
            }
        },
        methods: {
            changeIMG() {
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    this.changeBack = !this.changeBack
                }
            }
        },
        created(){
            this.changeIMG();
        },
        mounted() {
            this.utils.getImg();
        },
        watch: {}
    }
</script>

<style lang="less">
    .img-pro {
        width: 100%;
        .tab-card {
            display: none;
            img {
                object-fit: cover;
            }
            .case-back {
                width: 100%;
                height: 580px;
                background-repeat: no-repeat;
                background-size: cover!important;
                background-position: center !important;
            }
        }
        .tab-card:nth-child(1) {
            display: block;
        }
    }

    @media screen and (max-width: 1680px) {
        .img-pro {
            .tab-card {
                .case-back {
                    width: 100%;
                    height: 500px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/changeImg.vue